import { useTheme } from '@material-ui/core';
import { Label } from 'components';

interface IProps {
    isPublic: boolean
    isFromCustomer: boolean
}

let MessageStatus = (props: IProps) => {
    let { palette } = useTheme();

    return (
        <Label color={props.isPublic === true ? palette.success.main : palette.error.main} variant="outlined">
            {props.isPublic === true
                ? <span>{props.isFromCustomer ? 'From customer' : 'Shared with customer'}</span>
                : <span>Videndum only</span>
            }
        </Label>
    )
}

export default MessageStatus;